<template>
    <v-app id="app">
        <!-- App bar -->
        <v-app-bar app clipped-right color="bal-gray" light flat>
            <v-app-bar-nav-icon large @click.stop="toggleDrawer" />
            <v-toolbar-title
                >{{ `${$route.meta.title}` | t
                }}<span style="color:gray;">{{ ` (${campaignsCount})` }}</span></v-toolbar-title
            >
            <v-combobox
                v-if="hasPermissionForAction(PermissionsConstants.CAMPAIGN, PermissionsConstants.SEARCH)"
                :items="searchHistory"
                :value="searchCampaignString"
                @input="controlSearchString($event)"
                item-text="keyword"
                id="searchInput"
                class="mt-6 mx-2"
                :placeholder="t('Campaign name, description, shop')"
                prepend-inner-icon="search"
                clearable
                flat
                solo
                dense
            >
                <template slot="item" slot-scope="data">
                    <span
                        @click="updateCampaignSearchOnClick(data.item.keyword)"
                        style="width: 100%; height: 100%"
                        class="pa-2"
                        >{{ data.item.keyword }}</span
                    >
                </template>
            </v-combobox>
            <v-spacer v-else />
            <v-btn
                dark
                color="bal-red"
                class="px-2 ml-2"
                style="min-width: 0;"
                v-if="hasPermissionForAction(PermissionsConstants.CAMPAIGN, PermissionsConstants.CREATE)"
                @click.stop="openNewCampaignDrawer"
            >
                <v-icon>add</v-icon>
            </v-btn>
        </v-app-bar>

        <!-- Drawer left -->
        <main-drawer :drawer-open="mainDrawerOpen" />

        <!--    Right drawer    -->
        <v-navigation-drawer :value="drawerOpen" fixed right hide-overlay width="900">
            <campaign-view v-if="$route.name === 'campaign-view'"></campaign-view>
            <campaign-edit v-if="$route.name === 'campaign-edit'"></campaign-edit>
        </v-navigation-drawer>

        <!-- Main content -->
        <v-main>
            <router-view />
        </v-main>

        <!-- Footer -->
        <page-footer />

        <v-snackbar color="success" bottom :timeout="2500" :value="requestSuccess">
            <div style="display: flex; flex-direction: row;">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ "Success" | t }}</div>
            </div>
        </v-snackbar>
    </v-app>
</template>
<script>
import MainDrawer from "../components/main-drawer.vue";
import PageFooter from "../components/page-footer.vue";

import CampaignView from "../pages/campaign/campaign-view.vue";
import CampaignEdit from "../pages/campaign/campaign-edit.vue";

import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { PermissionsConstants } from "@/permissions";

export default {
    components: {
        CampaignView,
        CampaignEdit,
        PageFooter,
        MainDrawer
    },
    data() {
        return {
            mainDrawerOpen: null
        };
    },
    async created() {
        await this.getSearchHistory(this.$route.path.replace("/", ""));
    },
    async mounted() {
        document.addEventListener("keydown", this.handleKeyboardListener);
        const drawerState = localStorage.getItem("mainDrawerOpen");
        if (drawerState) {
            this.mainDrawerOpen = JSON.parse(drawerState);
        } else {
            this.mainDrawerOpen = true;
        }
        if (this.export_clients.length === 0) {
            await this.getFrequentlyUsedQueries({ export_clients: true, stores: true, tags: true, clients: true });
        }
    },
    async destroyed() {
        if (this.searchCampaignString.length > 0) await this.resetCampaignSearch();
        document.removeEventListener("keydown", this.handleKeyboardListener);
        await this.setRequestSuccess(false);
        await this.setErrorMessage("");
    },
    methods: {
        ...mapMutations("CampaignStore", [
            "resetActiveCampaign",
            "updateCampaignSearch",
            "setRequestSuccess",
            "setErrorMessage",
            "resetCampaignSearch"
        ]),
        ...mapActions("SearchHistoryStore", ["getSearchHistory"]),
        ...mapActions("CampaignStore", ["getCampaignData"]),
        ...mapActions(["getFrequentlyUsedQueries"]),
        openNewCampaignDrawer() {
            return this.$router.push({ name: "campaign-edit", params: { campaignId: "new" } });
        },
        async updateUserSearch(value) {
            await this.updateUserSearch({ term: value });
            await this.setRequestSuccess(false);
            await this.setErrorMessage("");
        },
        toggleDrawer() {
            this.mainDrawerOpen = !this.mainDrawerOpen;
            localStorage.setItem("mainDrawerOpen", this.mainDrawerOpen);
        },
        async handleKeyboardListener(e) {
            if (e.keyCode === 27 && this.mainDrawerOpen) {
                await this.resetActiveCampaign();
                return await this.$router.push({ name: "campaign-list" });
            } else if (e.keyCode === 13 && document.activeElement.tagName === "INPUT") {
                await this.updateCampaignSearch({
                    term: document.querySelector("#searchInput").value
                });
            }
            if (
                this.activeCampaign &&
                Object.keys(this.activeCampaign).length > 0 &&
                this.activeCampaign.id !== "new" &&
                this.$route.name !== "campaign-edit"
            ) {
                let currentCampaignIndex = this.campaigns[this.activeCampaign.info_provider].findIndex(
                    p => p.id === this.activeCampaign.id
                );
                if (e.key === "ArrowUp") {
                    if (currentCampaignIndex !== 0) {
                        const newCampaignId = this.campaigns[this.activeCampaign.info_provider][
                            currentCampaignIndex - 1
                        ].id;
                        await this.getCampaignData(newCampaignId);
                        return await this.$router.push({
                            name: this.$route.name,
                            params: { campaignId: newCampaignId }
                        });
                    }
                } else if (e.key === "ArrowDown") {
                    if (currentCampaignIndex + 1 !== this.campaigns[this.activeCampaign.info_provider].length) {
                        const newCampaignId = this.campaigns[this.activeCampaign.info_provider][
                            currentCampaignIndex + 1
                        ].id;
                        await this.getCampaignData(newCampaignId);
                        return await this.$router.push({
                            name: this.$route.name,
                            params: { campaignId: newCampaignId }
                        });
                    }
                }
            }
        },
        async updateCampaignSearchOnClick(value) {
            await this.updateUserSearch({
                term: value
            });
        },
        controlSearchString(value) {
            if (value === "") this.updateUserSearch(value);
        }
    },
    computed: {
        ...mapState("CampaignStore", [
            "drawerOpen",
            "searchCampaignString",
            "requestSuccess",
            "campaigns",
            "activeCampaign",
            "campaignsCount"
        ]),
        ...mapState("SearchHistoryStore", ["searchHistory"]),
        ...mapState(["export_clients"]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    }
};
</script>

<style scoped>
.v-input__icon--prepend-inner .v-icon {
    margin-top: 0px !important;
}
</style>
